import  { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const getInitials = (firstName: string, lastName: string) => {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};

const getAvatarColor = (name: string) => {
  const colors = ['bg-teal-500', 'bg-blue-500', 'bg-purple-500', 'bg-pink-500', 'bg-indigo-500', 'bg-green-500', 'bg-orange-500', 'bg-red-500'];
  const index = name.charCodeAt(0) % colors.length;
  return colors[index];
};

export default function TestimonialsSection(){
    const [currentTestimonial, setCurrentTestimonial] = useState(0);
    
      
      const testimonials = [
        {
          firstName: 'Dhawal',
          lastName: 'Goswami',
          role: 'Wellness Enthusiast',
          text: 'I had a wonderful experience with the yoga classes. The instructor is highly experienced and knowledgeable, which truly reflects in the quality of the sessions. The class timings are well-scheduled and convenient, and the overall teaching approach is both professional and effective.',
          rating: 5,
          program: 'Yoga Classes'
        },
        {
          firstName: 'Deepak',
          lastName: 'Mudaliar',
          role: 'Local Guide',
          text: 'Metafit has some amazing experts in the field of Ayurvedic and naturopathy. They help you grow healthy organically and efficiently without any major expenses. Must enroll for a healthy lifestyle.',
          rating: 5,
          program: 'Ayurveda & Naturopathy'
        },
        {
          firstName: 'Rekha',
          lastName: 'Soni',
          role: 'Local Guide',
          text: 'Absolutely love the energies of Meenakshi ji, the way she promotes herself with so well equipped knowledge of food, fitness and yoga … and the love and compassion she gives to everyone.',
          rating: 5,
          program: 'Fitness & Wellness'
        },
        {
          firstName: 'Rohit',
          lastName: 'Paliwal',
          role: 'Local Guide',
          text: 'Metafit Wellness is truly the best platform for holistic wellness! It\'s amazing to find yoga, Ayurveda, and naturopathy—all in one place. The experience is seamless, and the quality of experts is top-notch. A big shoutout to the founder, Ms. Meenakshi Paliwal, whose vision and dedication have brought this unique and much-needed platform to life.',
          rating: 5,
          program: 'Holistic Wellness'
        },
        {
          firstName: 'Mahima',
          lastName: 'Sarupria',
          role: 'Health Enthusiast',
          text: 'They have experienced and qualified yoga teachers to help you through your fitness journey. Best of all. The instructors are truly dedicated to your wellness goals and progress.',
          rating: 5,
          program: 'Yoga Teachers Training'
        },
        {
          firstName: 'B.',
          lastName: 'Bishnoi',
          role: 'Fitness Member',
          text: 'Absolutely love the energy and intensity at MetaFit – every session pushes me to my limits and leaves me feeling stronger! The community here is supportive and motivating.',
          rating: 5,
          program: 'Fitness Programs'
        },
        {
          firstName: 'Meenakshi',
          lastName: 'Gupta',
          role: 'Wellness Advocate',
          text: 'Highly recommended if you\'re looking for a one stop solution for leading a healthy lifestyle. Excellent wellness solution with everything you need in one platform.',
          rating: 5,
          program: 'Holistic Health'
        },
        {
          firstName: 'Ayushi',
          lastName: 'Jain',
          role: 'Weight Loss Member',
          text: 'Very helpful for my weight loss journey. The personalized guidance and expert support have made a real difference in achieving my fitness goals.',
          rating: 5,
          program: 'Weight Loss Program'
        }
      ];
    
     const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

    return(
      <div className="relative overflow-hidden bg-white py-16 lg:py-24">
        <div className="absolute inset-0 opacity-40">
          <div className="absolute -left-16 top-10 h-64 w-64 rounded-full bg-[#1C8F86]/10 blur-3xl" />
          <div className="absolute right-0 bottom-0 h-72 w-72 rounded-full bg-[#D3F7F1]/50 blur-3xl" />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="text-center mb-10"
          >
            <p className="text-[11px] sm:text-xs font-semibold tracking-[0.25em] uppercase text-[#1C8F86] mb-3">
              Testimonials
            </p>
            <h2 className="text-3xl sm:text-4xl font-semibold text-[#15302B] mb-3">Real stories from our wellness community</h2>
            <p className="text-base sm:text-lg text-[#4D625D]">Warm, honest feedback from people who trained with us.</p>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <div className="rounded-3xl border border-[#E0D4B8]/60 bg-white/60 p-6 sm:p-8 shadow-[0_20px_50px_-20px_rgba(21,48,43,0.12)] backdrop-blur-md overflow-hidden relative">
              <AnimatePresence mode="wait">
                <motion.div 
                  key={currentTestimonial}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-6">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white text-lg font-bold ${getAvatarColor(testimonials[currentTestimonial].firstName)}`}>
                      {getInitials(testimonials[currentTestimonial].firstName, testimonials[currentTestimonial].lastName)}
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-[#15302B]">{testimonials[currentTestimonial].firstName} {testimonials[currentTestimonial].lastName}</h3>
                      <div className="flex items-center gap-3 mt-1">
                        <p className="text-sm text-[#5F6F6A]">{testimonials[currentTestimonial].role}</p>
                        <div className="w-1 h-1 rounded-full bg-[#E0D4B8]"></div>
                        <div className="flex text-[#F6C343]">
                          {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                            <Star key={i} size={14} fill="currentColor" />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-[#4D625D] text-base sm:text-lg leading-relaxed mb-6 italic">
                    "{testimonials[currentTestimonial].text}"
                  </p>
                  <div className="inline-flex rounded-full bg-[#D3F7F1]/80 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-[#1C8F86]">
                    {testimonials[currentTestimonial].program}
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
            
            <button
              onClick={prevTestimonial}
              className="absolute left-0 top-1/2 -translate-x-3 sm:-translate-x-5 -translate-y-1/2 rounded-full border border-[#E0D4B8] bg-white p-2.5 shadow-lg transition-transform hover:scale-105 z-10"
            >
              <ChevronLeft size={20} className="text-[#15302B]" />
            </button>
            <button
              onClick={nextTestimonial}
              className="absolute right-0 top-1/2 translate-x-3 sm:translate-x-5 -translate-y-1/2 rounded-full border border-[#E0D4B8] bg-white p-2.5 shadow-lg transition-transform hover:scale-105 z-10"
            >
              <ChevronRight size={20} className="text-[#15302B]" />
            </button>
          </motion.div>
          
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-2.5 h-2.5 rounded-full transition-colors ${
                  index === currentTestimonial ? 'bg-[#1C8F86]' : 'bg-[#1C8F86]/20'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    )
}
